import { HIDDEN } from '../../classnames/design-system';

export default class BaseDropdown {
  getMenuSection = () => document.getElementById(this.menuSectionId);
  getMenuOption = () => document.getElementById(this.menuOptionId);

  showSupplementsMenu = () => {
    this.getMenuSection().classList.remove(HIDDEN);
  };

  hideSupplementsMenu = () => {
    this.clearMenuOption();
    this.getMenuSection().classList.add(HIDDEN);
  };

  clearMenuOption = () => {
    this.getMenuOption().classList.remove('navigation__link--selected');
  };

  initializeEventListeners = () => {
    if (this.getMenuOption() && this.getMenuSection()) {
      this.getMenuOption().addEventListener('mouseover', this.showSupplementsMenu);
      this.getMenuOption().addEventListener('mouseout', this.hideSupplementsMenu);

      this.getMenuSection().addEventListener('mouseout', this.clearMenuOption);
    }
  };
}
